import { Trans } from 'react-i18next'

import { actionLabelMap } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { useWorkflowNodeContext } from '../WorkflowActionFormModal'
import { PanelsMap } from './panels'
import { PanelProps } from './panels/panel.type'

type ActionOutputPanelProps = PanelProps

export default function ActionOutputPanel({ panelType, actionType, inputValue, data }: ActionOutputPanelProps) {
  const nodeContext = useWorkflowNodeContext()
  const Panel = PanelsMap[nodeContext?.currentNode?.data?.actionValue?.type as keyof typeof PanelsMap]

  const nodeType = nodeContext?.currentNode?.data?.actionValue?.type

  const typeName = actionLabelMap[nodeType as keyof typeof actionLabelMap] || nodeType
  const nodeLabel = nodeContext?.currentNode?.data?.actionValue?.label ?? ''

  return (
    <div className='h-full flex flex-col border-l border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900'>
      {/* Header */}
      <div className='border-b border-gray-200 dark:border-gray-700 p-4'>
        <div className='flex items-center gap-2'>
          <MaterialIcon icon='output' size={20} className='text-gray-600 dark:text-gray-400' />
          <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
            <Trans>Output</Trans>
          </h3>
        </div>
        <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>
          <Trans>Data coming out of this step</Trans>
        </p>
      </div>

      {/* Content */}
      <div className='flex-1 p-4 space-y-4'>
        <div className='space-y-4'>
          {/* Current Step Info */}
          {/* <div>
            <div className='text-sm font-medium text-gray-900 dark:text-white mb-2'>
              <Trans>Current Step:</Trans>
            </div>
            <div className='bg-white dark:bg-gray-800 rounded-lg p-3 border border-gray-200 dark:border-gray-600'>
              <div className='text-sm font-medium text-gray-900 dark:text-white'>{nodeLabel}</div>
              <div className='text-xs text-gray-500 dark:text-gray-400 mt-1'>Type: {typeName}</div>
            </div>
          </div> */}

          {Panel && <Panel data={data} panelType={panelType} actionType={actionType} inputValue={inputValue} />}
        </div>
      </div>
    </div>
  )
}
